import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { ToasterService } from '@shared/services/toaster.service';
import { BaseResponse } from '@core/interfaces';
import { Observable } from 'rxjs';
import { API_ENDPOINTS, LOG_IN_ROUTE } from '@shared/constants';
import { AuthService } from '@core/services';
import { Router } from '@angular/router';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const toasterMessage = inject(ToasterService);

  // Skip showing toast messages for silent requests (e.g., polling)
  const skipMessages = req.headers.get('X-Skip-Messages') === 'true';
  const cleanedReq = skipMessages
    ? req.clone({ headers: req.headers.delete('X-Skip-Messages') })
    : req;

  return next(cleanedReq).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const responseBody = event.body as BaseResponse<object>;
        if (skipMessages) {
          // Skip showing any messages for silent requests
          return event;
        }
        if (
          (responseBody?.status == 200 || responseBody?.status == 202) &&
          responseBody.message !== null &&
          responseBody.message !== undefined &&
          responseBody.message !== ''
        ) {
          toasterMessage.showSuccess(responseBody.message);
        } else if (
          ![200, 401, 500].includes(responseBody.status) &&
          responseBody.message !== null &&
          responseBody.message !== undefined &&
          responseBody.message !== ''
        ) {
          toasterMessage.showErrorMessage(responseBody.message);
        } else if (responseBody.status === 500) {
          throw new Error('Internal server error');
        }
      }
      return event;
    }),
    catchError(error => {
      let errorMessage = error.error ? error.error.message : error.message;
      if (error.status === 500) {
        errorMessage = 'Internal server error';
      }
      if (error.status === 401) {
        errorMessage =
          'Authentication credentials were not provided or are invalid.';
        if (req.url === API_ENDPOINTS.Identity.Logout) {
          authService.clearCurrentUser();
          router.navigate([LOG_IN_ROUTE]);
        } else {
          authService.logout().subscribe(() => {
            router.navigate([LOG_IN_ROUTE]);
          });
        }
      }
      toasterMessage.showErrorMessage(errorMessage);

      throw error;
    })
  );
};
